import { useState } from 'react';
import ToollBar from './Toollbar';
import ListBoard from './ListBoard';
import SupportTable from './SupportTable';
import {
    normalizeSupportTableColumnsSettings,
    readSupportTableColumnsSettings,
    saveSupportTableColumnsSettings,
} from './supportTableColumns';
import type { IOccurrence, SupportViewType } from '../types';
import type { SelectOption } from '@rio-cloud/rio-uikit';
import { getSortOptionId } from './SortOptionsSupport';

interface Props {
    data: IOccurrence[];
    handleSearch: (text: string) => void;
    handleDn: (text: string) => void;
    handleSupportType: (subject: string) => void;
    handleSort: (optionId: string) => void;
    isLoading: boolean;
    optionsAssigned: SelectOption[];
    search?: string;
    dn?: string;
    sortBy?: string;
    sortDirection?: string;
    supportType: string;
    handleAssignedChange: (values: string[]) => void;
    assignedSelection: string[];
    onOpenSettings: () => void;
    viewType: SupportViewType;
    onViewTypeChange: (viewType: SupportViewType) => void;
}

const SupportBoard = ({
    data,
    handleSearch,
    handleSupportType,
    handleDn,
    handleSort,
    isLoading,
    optionsAssigned,
    search,
    dn,
    sortBy,
    sortDirection,
    supportType,
    handleAssignedChange,
    assignedSelection,
    onOpenSettings,
    viewType,
    onViewTypeChange,
}: Props) => {
    const [columnsSettings, setColumnsSettings] = useState(readSupportTableColumnsSettings);

    const handleColumnChange = (newColumnOrder: string[], newHiddenColumns: string[]) => {
        const nextSettings = normalizeSupportTableColumnsSettings(newColumnOrder, newHiddenColumns);

        setColumnsSettings(nextSettings);
        saveSupportTableColumnsSettings(nextSettings);
    };

    return (
        <div>
            <ToollBar
                handleSearch={handleSearch}
                handleSupportType={handleSupportType}
                handleDn={handleDn}
                handleSort={handleSort}
                optionsAssigned={optionsAssigned}
                search={search}
                dn={dn}
                sortBy={sortBy}
                sortDirection={sortDirection}
                supportType={supportType}
                handleAssignedChange={handleAssignedChange}
                assignedSelection={assignedSelection}
                onOpenSettings={onOpenSettings}
                viewType={viewType}
                onViewTypeChange={onViewTypeChange}
                columnOrder={columnsSettings.columnOrder}
                hiddenColumns={columnsSettings.hiddenColumns}
                onColumnChange={handleColumnChange}
            />
            {viewType === 'kanban' ? (
                <ListBoard data={data} isLoading={isLoading} />
            ) : (
                <SupportTable
                    data={data}
                    isLoading={isLoading}
                    columnOrder={columnsSettings.columnOrder}
                    hiddenColumns={columnsSettings.hiddenColumns}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    onSort={(nextSortBy, nextSortDirection) =>
                        handleSort(getSortOptionId(nextSortBy, nextSortDirection))
                    }
                />
            )}
        </div>
    );
};

export default SupportBoard;
